import React from 'react';
import { Loading } from '@drift-labs/icons';

const ArcLoadingSpinner = (props: { size?: number; color?: string }) => {
	return (
		<Loading color={props.color} size={props.size} className="animate-spin" />
	);
};

export default ArcLoadingSpinner;
